"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.columns = void 0;
var columns = 12; // DHIG grid is 12 columns wide according to the spec here: https://digital-hig.autodesk.com/grid/

exports.columns = columns;
var spacing = {
  xs: 4,
  sm: 4,
  md: 5,
  lg: 6
}; // DHIG grid has standard gutter sizes at various breakpoints according to the spec here: https://digital-hig.autodesk.com/grid/

exports.spacing = spacing;